/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ summary: NonNullable<unknown> }} Import_Progress_PhotosInputs */

const cs_import_progress_photos = /** @type {(inputs: Import_Progress_PhotosInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fotky: ${i?.summary}`)
};

const en_import_progress_photos = /** @type {(inputs: Import_Progress_PhotosInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Photos: ${i?.summary}`)
};

/**
* | output |
* | --- |
* | "Photos: {summary}" |
*
* @param {Import_Progress_PhotosInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_progress_photos = /** @type {((inputs: Import_Progress_PhotosInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Progress_PhotosInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_progress_photos(inputs)
	return cs_import_progress_photos(inputs)
});